import { useCorptaxTheme } from '@corptax/react-components-common';
import { IContextualMenuItem, IContextualMenuProps, mergeStyles } from '@fluentui/react';
import { registerIcons } from '@fluentui/react/lib/Styling';
import { useTranslation } from 'react-i18next';
import { ISelectedTaxReturnsAndFilters } from '../../data-types/exportReports';
import { useExportReports } from '../../hooks/useExportReports';
import { ReportListRequest } from '../../model';
import { IAppTheme } from '../../theme/IAppTheme';
import CustomIconButton from './IconButton';

export interface IExportReportButtonProps {
    disabled?: boolean;
    compareVersionId?: string;
    getReportsToExport: () => ISelectedTaxReturnsAndFilters;
}

registerIcons({
    icons: {
        CustomExcelDocument: (
            <svg width='12' height='16' viewBox='0 0 12 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M2 8.5C2 7.67157 2.67157 7 3.5 7H8.5C9.32843 7 10 7.67157 10 8.5V12.5C10 13.3284 9.32843 14 8.5 14H3.5C2.67157 14 2 13.3284 2 12.5V8.5ZM4 13V11H3V12.5C3 12.7761 3.22386 13 3.5 13H4ZM5 10H9V8.5C9 8.22386 8.77614 8 8.5 8H5V10ZM5 13H8.5C8.77614 13 9 12.7761 9 12.5V11H5V13ZM3.5 8C3.22386 8 3 8.22386 3 8.5V10H4V8H3.5ZM2 0C0.89543 0 0 0.895431 0 2V14C0 15.1046 0.89543 16 2 16H10C11.1046 16 12 15.1046 12 14V5.41421C12 5.01639 11.842 4.63486 11.5607 4.35355L7.64645 0.43934C7.36514 0.158035 6.98361 0 6.58579 0H2ZM1 2C1 1.44772 1.44772 1 2 1H6V4.5C6 5.32843 6.67157 6 7.5 6H11V14C11 14.5523 10.5523 15 10 15H2C1.44772 15 1 14.5523 1 14V2ZM10.7929 5H7.5C7.22386 5 7 4.77614 7 4.5V1.20711L10.7929 5Z'
                    fill='currentColor'
                />
            </svg>
        ),
        PdfDocument: (
            <svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M3.50006 9C3.22392 9 3.00006 9.22386 3.00006 9.5V11.5C3.00006 11.7761 3.22392 12 3.50006 12C3.7762 12 4.00006 11.7761 4.00006 11.5V11.3336H4.33326C4.97767 11.3336 5.50006 10.8112 5.50006 10.1668C5.50006 9.52239 4.97767 9 4.33326 9H3.50006ZM4.33326 10.3336H4.00006V10H4.33326C4.42538 10 4.50006 10.0747 4.50006 10.1668C4.50006 10.2589 4.42538 10.3336 4.33326 10.3336ZM9.00077 9.49937C9.00112 9.22347 9.22488 9 9.50077 9H10.4991C10.7752 9 10.9991 9.22386 10.9991 9.5C10.9991 9.77614 10.7752 10 10.4991 10H10.0001L9.99972 10.3345H10.4991C10.7752 10.3345 10.9991 10.5583 10.9991 10.8345C10.9991 11.1106 10.7752 11.3345 10.4991 11.3345H10.0004L10.0008 11.4987C10.0015 11.7749 9.77818 11.9993 9.50204 12C9.22589 12.0007 9.00147 11.7774 9.00077 11.5013L8.99908 10.8339L9.00077 9.49937ZM6.49866 9C6.22252 9 5.99866 9.22386 5.99866 9.5V11.5C5.99866 11.7761 6.22252 12 6.49866 12H7.0001C7.82853 12 8.5001 11.3284 8.5001 10.5C8.50011 9.67158 7.82854 9 7.0001 9H6.49866ZM6.99866 11V10H7.0001C7.27625 10 7.50011 10.2239 7.5001 10.5C7.5001 10.7761 7.27625 11 7.0001 11H6.99866ZM1.00006 2C1.00006 0.895431 1.89549 0 3.00006 0H7.58585C7.98367 0 8.3652 0.158035 8.64651 0.43934L12.5607 4.35355C12.842 4.63486 13.0001 5.01639 13.0001 5.41421V7.08165C13.582 7.28793 13.9988 7.84321 13.9988 8.49585V12.499C13.9988 13.1517 13.582 13.707 13.0001 13.9132V14C13.0001 15.1046 12.1046 16 11.0001 16H3.00006C1.89549 16 1.00006 15.1046 1.00006 14V13.9132C0.418199 13.7069 0.00146484 13.1516 0.00146484 12.499V8.49585C0.00146484 7.84326 0.418198 7.28801 1.00006 7.0817V2ZM12.0001 6H8.50006C7.67163 6 7.00006 5.32843 7.00006 4.5V1H3.00006C2.44778 1 2.00006 1.44772 2.00006 2V6.99585H12.0001V6ZM2.00006 13.999C2.00006 14.5513 2.44778 15 3.00006 15H11.0001C11.5523 15 12.0001 14.5513 12.0001 13.999H2.00006ZM8.00006 1.20711V4.5C8.00006 4.77614 8.22392 5 8.50006 5H11.793L8.00006 1.20711ZM1.50146 7.99585C1.22532 7.99585 1.00146 8.21971 1.00146 8.49585V12.499C1.00146 12.7752 1.22532 12.999 1.50147 12.999H12.4988C12.7749 12.999 12.9988 12.7752 12.9988 12.499V8.49585C12.9988 8.21971 12.7749 7.99585 12.4988 7.99585H1.50146Z'
                    fill='currentColor'
                />
            </svg>
        ),
    },
});

const ExportReportButton: React.FC<IExportReportButtonProps> = ({ getReportsToExport, disabled, compareVersionId }) => {
    const { t } = useTranslation();
    const { exportToExcelMutation, exportToPdfMutation, setExportedReports, isProcessing, exportTaxReturnListToExcelMutation } =
        useExportReports();
    const { customPalette } = useCorptaxTheme<IAppTheme>();
    const menuItemsStyles = mergeStyles({
        '& > button': {
            fontWeight: '600',
        },
        '& > button:hover': {
            color: customPalette.themePrimary,
            backgroundColor: customPalette.themeLighter,
        },
        '* > i': {
            marginLeft: '10px',
        },
    });

    const menuItemsTitleStyles = mergeStyles({
        '* > span': {
            fontWeight: '600',
            color: customPalette.neutralGrey,
        },
        '* > i': {
            display: 'none',
        },
    });

    const getRequestsForExport = (validateExecutedReturns?: boolean): ISelectedTaxReturnsAndFilters | undefined => {
        try {
            const reports = getReportsToExport();
            ensureAllSelectedReportsHaveExecuted(reports, validateExecutedReturns, t('notExecutedReportSelectedForExportError'));

            setExportedReports(reports.selectedTaxReturns);

            return reports;
        } catch (err: any) {
            setExportedReports([]);
            alert(err);
            return undefined;
        }
    };

    const exportToExcel = () => {
        const requests = getRequestsForExport(true);

        if (requests) {
            exportToExcelMutation({ data: requests.selectedTaxReturns || [] });
        }
    };

    const exportToPdf = () => {
        const requests = getRequestsForExport(true);

        if (requests) {
            exportToPdfMutation({ data: requests.selectedTaxReturns || [] });
        }
    };

    const exportTaxReturnToExcel = () => {
        const requests = getRequestsForExport();

        if (requests?.filters) {
            const adaptedRequests: ReportListRequest = {
                selectedCases: requests.filters.SelectedCases,
                selectedEntities: requests.filters.SelectedEntities,
                selectedIds: (requests?.selectedTaxReturns?.map((item) => item.id) as number[]) || [],
                selectedJurisdictions: requests.filters.SelectedJurisdictions,
                selectedPeriods: requests.filters.SelectedPeriods,
            };

            exportTaxReturnListToExcelMutation({ data: adaptedRequests });
        }
    };

    const menuItems: IContextualMenuItem[] = [
        {
            key: 'excel-export-tax-return-title',
            name: t('exportSelectedReports').toString(),
            className: menuItemsTitleStyles,
            onClick: (e) => {
                e?.preventDefault();
            },
            iconProps: {
                hidden: true,
            },
        },
        {
            key: 'excel-export',
            name: t('exportAsXlsx').toString(),
            onClick: exportToExcel,
            className: menuItemsStyles,
            iconProps: {
                iconName: 'CustomExcelDocument',
            },
        },
        {
            key: 'pdf-export',
            name: t('exportAsPdf').toString(),
            onClick: exportToPdf,
            className: menuItemsStyles,
            iconProps: {
                iconName: 'PdfDocument',
            },
        },
        {
            key: 'excel-export-tax-return-divider',
            text: '-',
        },
        {
            key: 'export-report-title',
            onClick: (e) => {
                e?.preventDefault();
            },
            name: t('exportList').toString(),
            className: menuItemsTitleStyles,
        },
        {
            key: 'excel-export-tax-return',
            name: t('exportAsXlsx').toString(),
            onClick: exportTaxReturnToExcel,
            className: menuItemsStyles,
            iconProps: {
                iconName: 'CustomExcelDocument',
            },
        },
    ];

    const exportMenuProps: IContextualMenuProps = {
        items: menuItems,
        className: mergeStyles({
            paddingTop: '10px',
            paddingBottom: '10px',
        }),
        ariaLabel: t('export').toString(),
    };

    return (
        <CustomIconButton
            label={t('export').toString()}
            iconName='ArrowDownload20Regular'
            menuProps={exportMenuProps}
            disabled={disabled}
            isProcessing={isProcessing}
        ></CustomIconButton>
    );
};
export const ensureAllSelectedReportsHaveExecuted = (
    reports: ISelectedTaxReturnsAndFilters,
    validateExecutedReturns = false,
    errorMessage: string
) => {
    if (validateExecutedReturns && !reports?.selectedTaxReturns?.every((report) => report.executed)) {
        throw errorMessage;
    }
};
export { ExportReportButton as default };
